import { Pressable, Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { SheetManager, type SheetProps } from 'react-native-actions-sheet'

import { cn } from '@/utils/cn'
import { Check } from '@/components/icon'

import { BottomSheet } from './BottomSheet'

export function OpenFilterSheet(props: SheetProps<'open-filter'>) {
  const { t } = useTranslation()

  const handlePress = (status: string) => {
    props.payload?.setValue(status)
    SheetManager.hide(props.sheetId)
  }

  const options = getOptions(props.payload?.type)

  return (
    <BottomSheet closeDrawer={props.payload?.closeDrawer}>
      {options.map((status) => {
        const selected = status === props.payload?.value
        return (
          <Pressable key={status} onPress={() => handlePress(status)}>
            {({ pressed }) => (
              <View className={cn('flex-row justify-between px-4 py-3', pressed && 'bg-background-secondary')}>
                <Text className={cn('text-base text-text-primary', selected && 'text-text-info')}>
                  {t(getTranslationKey(props.payload?.type, status))}
                </Text>
                {selected && <Check className={'size-6 text-primary'} />}
              </View>
            )}
          </Pressable>
        )
      })}
    </BottomSheet>
  )
}

function getOptions(type?: string) {
  switch (type) {
    case 'open-fast-track-order': {
      return ['all', 'creating', 'awaitSettlement', 'adminResolving']
    }
    case 'closed-fast-track-order': {
      return ['all', 'completed', 'failed', 'timedOut']
    }
    case 'open-buy-order':
    case 'open-sell-order': {
      return ['all', 'unpaired', 'paired', 'paymentMade', 'complainted', 'canceling', 'appealing']
    }
    case 'closed-buy-order':
    case 'closed-sell-order': {
      return ['all', 'completed', 'canceled']
    }
  }
  return []
}

function getTranslationKey(type: string | undefined, status: string) {
  if (type?.includes('fast-track')) {
    return `orderList:fastTrack.${status}`
  }
  return `orderList:tags.${type?.includes('buy') ? 'buy' : 'sell'}.${status}`
}
